export const selectForm = state => state.form;

export const selectFormData = state => {
  const form = selectForm(state);
  return form && form.data;
};

export const selectFormDataAddressComponents = state => {
  const formData = selectFormData(state);
  return (
    formData && {
      address: formData.address,
      address2: formData.address2,
      city: formData.city,
      state: formData.state,
      zipcode: formData.zipcode,
    }
  );
};
/** Returns a users US state from the form data if they have entered one. Used
 * by inputs/OriginOfAwarenessSelect.js */
export const selectFormDataStateCode = state => {
  const formData = selectFormData(state);
  return formData && formData.state;
};

/** Returns a users email from the form data if they have entered one. */
export const selectFormDataEmail = state => {
  const formData = selectFormData(state);
  return formData && formData.email;
};

export const selectFormDataPhone = state => {
  const formData = selectFormData(state);
  return formData && formData.phone;
};

export const selectFormDataPayType = state => {
  const formData = selectFormData(state);
  return formData && formData.payType;
};

export const selectFormDataSourceOfIncome = state => {
  const formData = selectFormData(state);
  return formData && formData.sourceOfIncome;
};

export const selectFormDataDateOfBirth = state => {
  const formData = selectFormData(state);
  return formData && formData.dateOfBirth;
};

export const selectFormHasData = state => {
  const form = selectForm(state);
  return form && form.hasData;
};

export const selectFormOrderId = state => {
  const form = selectForm(state);
  return form && form.orderId;
};

export const selectFormFirstName = state => {
  const formData = selectFormData(state);
  return formData && formData.firstName;
};

export const selectFormLastName = state => {
  const formData = selectFormData(state);
  return formData && formData.lastName;
};

export const selectPrefilledNameValues = state => {
  const formData = selectFormData(state);
  return !!(formData && formData.firstName && formData.lastName);
};
